import { type ReactNode } from "react";
import { Trans } from "react-i18next";
import { type I18nTFunctionBound } from "@/types/customTypes";

interface RichTransProps {
  i18nKey: Parameters<I18nTFunctionBound>[0];
  className?: string;
  children?: ReactNode;
  values?: Record<string, unknown>;
}

export function RichTrans({
  i18nKey,
  className,
  children,
  values,
  ...props
}: RichTransProps) {
  return (
    <Trans
      // @ts-expect-error -- too complex shit
      i18nKey={i18nKey}
      components={{
        b: <b />,
        strong: <strong className="font-extrabold" />,
        i: <i />,
        em: <em />,
        span: <span />,
        div: <div />,
        p: <p />,
        br: <br />,
        a: (
          <a className="text-blue-600 underline transition-colors hover:text-blue-700" />
        ),
      }}
      className={className}
      values={values}
      {...props}
    >
      {children}
    </Trans>
  );
}
